import { createI18n } from "vue-i18n";
import zhcnLocale from "element-plus/lib/locale/lang/zh-cn";
import enLocale from "element-plus/lib/locale/lang/en";
import nextZhcn from "/@/i18n/lang/zh-cn";
import nextEn from "/@/i18n/lang/en";
const messages = {
  en: {
    ...nextEn,
  },
  zh_cn: {
    ...nextZhcn,
  },
};

// 导出语言国际化
export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: localStorage.getItem("lang") || "zh_cn",
  fallbackLocale: zhcnLocale.name,
  messages,
});
